import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useContext } from 'react'

import { ToggleGroup, ToggleGroupItem } from '@/components/elements/toggle-group'
import { updateUser } from '@/services/user.service'
import { UserStoreContext } from '@/stores/UserStore'
import { toast } from '@/utils/helpers'

import { SharedCardLayout } from './layout'

const SecurityNotificationsSection = () => {
  const { user } = useContext(UserStoreContext)
  const queryClient = useQueryClient()

  const { isPending: loading, mutate: mutateUser } = useMutation({
    mutationFn: (data) => updateUser(data),
    onError: (err) => toast(err.message, 'error'),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['users'] })
    },
  })

  return (
    <SharedCardLayout title="Account Security">
      <SharedCardLayout.Fields>
        <div className="flex items-center justify-between gap-4">
          <div className="flex flex-col justify-center">
            <span className="text-base">Multi-factor Authentication</span>
            <span className="text-sm text-gray-500">
              {!user.phoneNumber
                ? 'To switch MFA to SMS, please add and verify a phone number.'
                : 'Select the MFA device you would like to use.'}
            </span>
          </div>
          <ToggleGroup
            type="single"
            variant="outline"
            onValueChange={(mfaDevice) => {
              mutateUser({
                id: user.id,
                mfaDevice,
              })
              toast(`MFA set to ${mfaDevice}.`, 'success')
            }}
            disabled={loading}
          >
            <ToggleGroupItem
              className="cursor-pointer px-5"
              value="Email"
              data-state={user.mfaDevice === 'Email' ? 'on' : 'off'}
            >
              E-mail
            </ToggleGroupItem>
            <ToggleGroupItem
              className="cursor-pointer px-5"
              value="Phone"
              data-state={user.mfaDevice === 'Phone' ? 'on' : 'off'}
              disabled={!user.phoneNumber}
            >
              Phone
            </ToggleGroupItem>
          </ToggleGroup>
        </div>

        {/* <hr className="my-10" />

        <CardTitle>Notifications</CardTitle>
        <CardDescription>Notification settings for your account.</CardDescription>
        <div className="mt-6">
          {['Courses', 'Events', 'Messages', 'Notifications'].map((item) => (
            <div key={item} className="mb-4 flex items-center justify-between gap-6">
              <div className="flex flex-col justify-center">{item}</div>
              <div>
                <ToggleGroup type="single" variant="outline">
                  {['E-mail', 'Phone', 'In-App', 'Off'].map((setting, index) => (
                    <ToggleGroupItem
                      key={setting}
                      className="cursor-pointer px-5"
                      value={setting}
                      data-state={index === 0 ? 'on' : 'off'}
                    >
                      {setting}
                    </ToggleGroupItem>
                  ))}
                </ToggleGroup>
              </div>
            </div>
          ))}
        </div> */}
      </SharedCardLayout.Fields>
    </SharedCardLayout>
  )
}

export default SecurityNotificationsSection
